// Please don't change values of constants since they are used in database

export const OVERVIEW = 'overview'

export const COMMENT_LIST = 'CommentListWidgetContainer'

export const CREATE_IPR_APPOINTMENT = 'CreateIprAppoinmentContainer'

export const STATE_TRANSITION_LOG_CONTAINER = 'StateTransitionLogContainer'

export const TECHNICAL_LOG_CONTAINER = 'TechnicalLogContainer'

export const SALES_ORDER_OVERVIEW_WIDGET = 'SalesOrderOverviewWidgetContainer'

export const SALES_ORDER_CUSTOMER_WIDGET = 'SalesOrderCustomerWidgetContainer'

export const SENT_EMAIL_WIDGET = 'SentEmailWidgetContainer'

export const WHATSAPP_MESSAGES_WIDGET = 'WhatsappMessagesWidgetContainer'

export const CUSTOMS_INVOICE_LIST_WIDGET = 'CustomsInvoiceListWidgetContainer'

export const INVOICE_LIST_WIDGET = 'InvoiceListWidgetContainer'

export const PAYMENT_LIST_WIDGET = 'PaymentListWidgetContainer'

export const TRAY_SIZE_WIDGET = 'TraySizeWidgetContainer'

export const IMPRINT_SCAN_STATUS_WIDGET = 'ImprintScanStatusWidgetContainer'

export const PHYSICIAN_AND_SUPPLIER_WIDGET =
    'PhysicianAndSupplierWidgetContainer'

export const TREATMENT_EXECUTION_WIDGET_CONTAINER =
    'TreatmentExecutionWidgetContainer'

export const TREATMENT_FEEDBACK_WIDGET =
    'TreatmentFeedbackWidgetContainer'

export const CUSTOMER_IMAGE_WIDGET = 'CustomerImageWidgetContainer'

export const CUSTOMER_IMAGE_UPLOAD_WIDGET = 'CustomerImageUploadWidgetContainer'

export const CUSTOMER_IMAGE_REUPLOAD_WIDGET = 'CustomerImageReuploadWidgetContainer'

export const CUSTOMER_CONTACT_WIDGET = 'CustomerContactWidgetContainer'

export const TREATMENT_PLAN_WIDGET = 'TreatmentPlanWidgetContainer'

export const SCAN_FILE_UPLOAD_WIDGET = 'ScanFileUploadWidgetContainer'

export const TREATMENT_PLAN_FILE_UPLOAD_WIDGET =
    'TreatmentPlanFileUploadWidgetContainer'

export const IPR_INSTRUCTIONS_WIDGET = 'IPRInstructionsWidgetContainer'

export const PATIENT_IPR_WISHES_WIDGET = 'PatientIPRWishesWidgetContainer'

export const TREATMENT_PLAN_EXTERNAL_FILE_UPLOAD_WIDGET =
    'TreatmentPlanExternalFileUploadWidgetContainer'

export const PRODUCTION_FILE_UPLOAD_WIDGET =
    'ProductionFileUploadWidgetContainer'

export const TREATMENT_QUOTATION_WIDGET = 'TreatmentQuotationWidgetContainer'

export const IMPLANT_TREATMENT_QUOTATION_WIDGET = 'ImplantTreatmentQuotationWidgetContainer'

export const REFUND_SEPA_TRANSFER_WIDGET = 'RefundSepaTransferWidgetContainer'

export const ALIGNER_LABEL_WIDGET_CONTAINER = 'AlignerLabelWidgetContainer'

export const CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER =
    'CannotBeTreatedReasonWidgetContainer'

export const PRE_TREATMENT_REASON_WIDGET_CONTAINER =
    'PreTreatmentReasonWidgetContainer'

export const WHATS_APP_TEXT_WIDGET_CONTAINER = 'WhatsAppTextWidgetContainer'

export const TREATMENT_DURATION_WIDGET_CONTAINER =
    'TreatmentDurationWidgetContainer'

export const SALES_NOTE_WIDGET_CONTAINER = 'SalesNoteWidgetContainer'

export const TREATMENT_CLASSIFICATION_WIDGET_CONTAINER =
    'TreatmentClassificationWidgetContainer'

export const TREATMENT_VISUALIZATION_WIDGET_CONTAINER =
    'TreatmentVisualizationWidgetContainer'

export const MOVEMENT_CERTIFICATE_NUMBER_WIDGET = 'MovementCertificateNumberWidgetContainer'

export const SHIPMENT_LIST_WIDGET_CONTAINER = 'ShipmentListWidgetContainer'

export const INITIAL_HESITATION_WIDGET_CONTAINER =
    'InitialHesitationWidgetContainer'

export const TRANSITION_LIST_WIDGET_CONTAINER = 'TransitionListWidgetContainer'

/* Treatment */

export const TREATMENT_PAYMENT_WIDGET = 'TreatmentPaymentWidgetContainer'

export const DELIVERY_TRACKING_WIDGET = 'DeliveryTrackingNumberWidgetContainer'

export const SUPPLIER_TRACKING_NUMBER_WIDGET =
    'SupplierTrackingNumberWidgetContainer'

export const PHOTO_CHECKIN_WIDGET = 'PhotoCheckinWidgetContainer'

export const MEDICAL_PHOTO_CHECK_WIDGET = 'MedicalPhotoCheckWidgetContainer'

export const INVOICE_CORRECTION_WIDGET = 'InvoiceCorrectionWidget'

export const PRODUCTION_CASE_CARD_WIDGET = 'ProductionCaseCardWidgetContainer'

export const MODEL_SELECTION_WIDGET = 'ModelSelectionWidgetContainer'

export const ALIGNER_CUSTOMER_COMMUNICATION_COMMENT_WIDGET = 'AlignerCustomerCommunicationCommentWidgetContainer'

export const ALIGNER_SEND_RECOMMENDATION_WIDGET = 'AlignerSendRecommendationWidgetContainer'

/* In Shop Scan */
export const CUSTOMER_TRANSFER_DRIVE_FILES_WIDGET =
    'TransferDriveFilesContainer'

export const MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER =
    'Match3ShapeCustomerWidgetContainer'

export const PATIENT_SCANNED_WIDGET = 'PatientScannedWidgetContainer'

export const COMPLEXITY_TREATMENT_WIDGET = 'ComplexityTreatmentWidgetContainer'

/* prospect */
export const PROSPECT_DETAIL_WIDGET_CONTAINER = 'ProspectDetailContainer'

export const PROSPECT_MEDICAL_CONDITION_WIDGET =
    'ProspectMedicalConditionContainer'

/* general */
export const VOUCHER_WIDGET_CONTAINER = 'VoucherContainer'

/* other */

export const ANAMNESIS_EDIT_WIDGET_CONTAINER = 'AnamnesisEditWidgetContainer'

export const ANAMNESIS_LIST_WIDGET_CONTAINER = 'AnamnesisListWidgetContainer'

export const APPOINTMENT_LIST_WIDGET_CONTAINER =
    'AppointmentListWidgetContainer'

export const PROCESS_OVERVIEW = 'ProcessOverview'

export const PROCESS_LIST = 'Process'

export const PROCESS_TASK_LIST = 'TaskList'

export const CONFORMITY_DECLARATION_LIST_WIDGET = 'ConformityDeclarationListWidgetContainer'

export const CUSTOMER_PRE_CHECKIN_IMAGE_WIDGET = 'CustomerPreCheckinImageWidgetContainer';

export const CBCT_FILE_UPLOAD_WIDGET = 'CbctFileUploadContainer';

export const IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET = 'ImplantTreatmentPlanUploadWidgetContainer'

export const CREATE_3DSCAN_APPOINTMENT = 'Create3DScanAppointmentContainer'

export const REFINEMENT_REASON_WIDGET = 'RefinementReasonWidgetContainer'

export const LOW_NPS_REASON_WIDGET_CONTAINER = 'LowNpsReasonWidgetContainer'

export const PARTIAL_INVOICE_CORRECTION_CONTAINER = 'PartialInvoiceCorrectionWidgetContainer';

export const CUSTOMER_XRAY_FILE_UPLOAD = 'XRayFileUploadContainer'

export const REQUEST_MEDICAL_EVALUATION = 'RequestMedicalEvalWidgetContainer'

export const ATTACHMENT_NEEDED_WIDGET = 'AttachmentNeededWidgetContainer'

export const ATTACHMENT_AGREEMENT_WIDGET = 'AttachmentAgreementWidgetContainer'



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/process-ui.js